<template>
  <div class="page">
    <c-source-form
      :columns="columns"
      :data="data"
      @submit="handleCreate"
    />
  </div>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator';
import createColumns from './columns';

@Component
export default class EditPricingRule extends Vue {

  data = {}

  get columns() {
    return createColumns.call(this)
  }

  async handleCreate(data) {
    const res = await this.$autoLoading(this.$request.post('/pricing_rules', data));
    this.$message.success('新建成功');
    this.$router.push({ name: 'pricing_rules.show', params: { id: res.id } });
  }
}
</script>
